import React from 'react';
import {
  FDStack,
  FDContentContainer,
} from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { Layout, metaOverrideSet } from './TaxDiagnosticTemplate';

const TaxDiagnosticPlannerPageTemplate = () => {
  const { pageContentResource } = usePageContentContext();

  useBoneBackgroundColor();

  return (
    <FDContentContainer maxWidth="lg">
      <FDStack direction="column" spacing={2}>
        <MetaResourceRenderer
          resource={pageContentResource}
          metaOverrideSet={metaOverrideSet}
          layout={Layout}
        />
      </FDStack>
    </FDContentContainer>
  );
};

TaxDiagnosticPlannerPageTemplate.defaultProps = {
};

TaxDiagnosticPlannerPageTemplate.propTypes = {
};

export default TaxDiagnosticPlannerPageTemplate;
